module.exports = __webpack_public_path__ + "img/department.1c0bdf93.png";